import React from 'react';
import { Chip, useTheme } from '@mui/material';

/**
 * MuiChip component to display Scope:
 *
 * @param {Object} props - Component's props.
 * @param {String} props.label - String. Label displayed in the chip component
 * @param {String} props.color - String. External provided color to override the stringToColor function.
 * @param {String} props.bgcolor - String. External backgroundColor only if provided
 *
 * @returns {React.JSX.Element}
 *
 *
 * N.B.: To wrap it with a muiTooltip, wrap it with a Div component and then wrap all with a Tooltip
 */

const CustomOutlinedChip = function CustomOutlinedChip({
  label = '',
  color = '',
}) {
  const theme = useTheme();
  return (
    <Chip
      id={`${label}-chip`}
      label={label}
      variant="outlined"
      size="small"
      sx={{
        color: color || theme.custom.stringToColor(label),
        borderColor: color || theme.custom.stringToColor(label),
        minWidth: '30px',
        width: 'min-content',
      }}
    />
  );
};

export default CustomOutlinedChip;
